import { Dtos } from "@inrev/common";
import { FC } from "react";
import { cn } from "../lib/utils";
import { Icon } from "../primitives";

export type FollowersProps = {
	followers?: Dtos.Follower.Get.Response[];
	onClick?: () => void;
};

export const Followers: FC<FollowersProps> = ({ followers, onClick }) => {
	return (
		<div
			data-testid="followers"
			className={cn(
				"flex items-center justify-center w-fit h-[24px] min-h-[24px] space-x-[5px] px-[10px] text-[12px] font-[550] text-secondary border border-bc-strong bg-surface-base rounded-full",
				onClick && "hover:text-primary hover:border-bc-stronger cursor-pointer",
			)}
			onClick={onClick}
		>
			<span>{followers ? followers.length : 0}</span>
			<Icon type="users" size="micro" color="secondary" />
		</div>
	);
};
